import {Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {Session} from "../../../services/Session";
import {ToastService} from "../../../services/Toast.service";
import {LoadingService} from "../../../services/LoadingService";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {TpiqFroalaViewComponent} from "../../../tpiq-froala-view/tpiq-froala-view.component";
import {FroalaViewModule} from "angular-froala-wysiwyg";

@Component({
  selector: 'app-tax-strategy-overview',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqFroalaViewComponent, FroalaViewModule],
  templateUrl: './tax-strategy-overview.component.html',
  styleUrl: './tax-strategy-overview.component.scss'
})
export class TaxStrategyOverviewComponent implements OnInit, OnDestroy {
  @Input() taxStrategy: any;
  @Input() showInfoTooltips: boolean = true;
  org: string =  Session.getOrg();
  user: string = Session.getUser().id;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  private complexityOptions = [
    {key: '1 - Single Input', value: '1' },
    {key: '2 - Multiple Inputs', value: '2' },
    {key: '3 - Conditional', value: '3' },
    {key: '4 - Complex', value: '4' },
    {key: '5 - Specialized', value: '5' }
  ];

  private urgencyOptions = [
    {key: '1 - No deadline', value: 'No deadline'},
    {key: '2 - Annual', value: 'Annual'},
    {key: '3 - Quarterly', value: 'Quarterly'},
    {key: '4 - Weeks', value: 'Weeks'},
    {key: '5 - Days', value: 'Days'}
  ];

  private riskOptions = [
    {key: '1 - Minimal', value: 'Sustained'},
    {key: '2 - Low', value: 'More Likely Than Not'},
    {key: '3 - Moderate', value: 'Substantial Authority'},
    {key: '4 - Heightened', value: 'Reasonable Basis'},
    {key: '5 - Significant', value: 'Listed/Reportable'}
  ];

  private burdenOptions = [
    {key: '1 - Mostly the client', value: 'Referral only'},
    {key: '2 - Client with advisor help', value: 'Light coordination'},
    {key: '3 - Half client/advisor', value: 'Shared work'},
    {key: '4 - Mostly tax advisor', value: 'Mostly advisor'},
    {key: '5 - Concierge', value: 'All advisor'}
  ];

  constructor(
    private toastService: ToastService,
    private loadingService: LoadingService,
    private taxStrategyServices: ManageTaxStrategiesServices
  ) {}

  ngOnInit() {
    this._init();
  }

  _init() {
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  displayComplexity(value: string): string {
    return this.displayLabel(value, this.complexityOptions);
  }

  displayUrgency(value: string): string {
    return this.displayLabel(value, this.urgencyOptions);
  }

  displayRisk(value: string): string {
    return this.displayLabel(value, this.riskOptions);
  }

  displayBurden(value: string): string {
    return this.displayLabel(value, this.burdenOptions);
  }

  private displayLabel(value: string, options: Array<{key: string; value: string}>): string {
    if (!value) {
      return '—';
    }
    const normalizedValue = (value || '').trim().toLowerCase();
    for (const opt of options) {
      if ((opt.value ?? '').trim().toLowerCase() === normalizedValue) {
        return opt.key;
      }

      if ((opt.key ?? '').split('-')[0].trim().toLowerCase() === normalizedValue) {
        return opt.key;
      }
    }

    return value;
  }

  getFileData(file, isForVisualImage?){
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.downloadDocument(this.user, this.org, file.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (isForVisualImage) {
          file.temporaryURL = response.temporaryURL;
          file.fileType = 'image';
        } else {
          window.open(response.temporaryURL);
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const errorMessage = (isForVisualImage) ? 'Failed to get image file document' : 'Failed to download document';
        this.toastService.pop(TOAST_TYPE.error, errorMessage);
      });
  }

}

